export default __webpack_public_path__ + "static/media/132122474_411805010169680_3785669703377696857_n.34f9994f.jpg";